import StorageCategory from "../services/storageCategory.service";
import { RETRIEVE_STORAGE_CATEGORIES, UPDATE_STORAGE_CATEGORY } from "./types";

export const retrieveStorageCategories = () => async (dispatch) => {
  try {
    const res = await StorageCategory.getAll();
    dispatch({
      type: RETRIEVE_STORAGE_CATEGORIES,
      payload: {
        rows: res?.data?.storageCategories?.rows,
        count: res?.data?.storageCategories?.count
      }
    });
  } catch (err) {
    console.log(err);
  }
};

export const updateStorageCategory = (id, data) => async (dispatch) => {
  try {
    const res = await StorageCategory.update(id, data);

    console.log(res);

    dispatch({
      type: UPDATE_STORAGE_CATEGORY,
      payload: res.data.storageCategory,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};
